<div>
    <app-vwsa-text text="The page you're looking for couldn't be found.">
    </app-vwsa-text>
</div>